import { useMemo } from "react";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { toOrganizationHistoryStart } from "./organizationHistoryStart.lib";
import { useOrganizationClients } from "./useOrganizationClients";

/** Where the firm's Activity history starts for the client filter, undefined until the firm and its clients load. */
export function useOrganizationHistoryStart(
    selectedClientIds: readonly string[] | undefined,
) {
    const organizationCreatedAt = useActiveOrganization()?.createdAt;
    const { data: clients } = useOrganizationClients();
    const start = useMemo(
        () =>
            toOrganizationHistoryStart({
                organizationCreatedAt,
                clients,
                selectedClientIds,
            }),
        [organizationCreatedAt, clients, selectedClientIds],
    );
    const startTime = start?.at.getTime();
    const startAt = useMemo(
        () => (startTime === undefined ? undefined : new Date(startTime)),
        [startTime],
    );
    return { startAt, clientName: start?.clientName };
}
